export const SUCCESS_GET_FUEL_RATES = 'SUCCESS_GET_FUEL_RATES';
export const FAILED_GET_FUEL_RATES = 'FAILED_GET_FUEL_RATES';
export const SUCCESS_GET_FUEL_RATE_HISTORY = 'SUCCESS_GET_FUEL_RATE_HISTORY';
export const FAILED_GET_FUEL_RATE_HISTORY = 'FAILED_GET_FUEL_RATE_HISTORY';



// WEBPACK FOOTER //
// src/state/constants/fuelRateConstants.js